var buttonClicks = 0;

// This function is to prevent JavaScript errors caused by Flash files calling old HitBox methods.
function hbURL(url, hb1, hb2)
{
  window.open(url, "Allstate")
  _hbPageView(hb1, hb2)
}
function hbTalk(num, hb1, hb2)
{
  webVoicePop('Template=57874'); //webVoicePop('Template='+num);
  _hbPageView(hb1, hb2)
}
// This function is a shell function to capture calls to the old HitBox functions made from Flash files.
// This can be removed once those Flash files are remediated.
function _hbPageView(param1, param2)
{
}
// End shell function.

function ProcessMetrics(metricName)
{
  ProcessMetrics(metricName, null);
}

function ProcessMetrics(metricName, variables)
{
  if (metricName == "GetQuote")
  {
    if (buttonClicks == 0)
    {
      var selectedValQuote = "";
      var arrQuote = variables[0].get_items();

      for (i = 0; i < arrQuote.length; i++)
      {
        if (arrQuote[i].Value == variables[0]._valDiv.value)
        {
          selectedValQuote = arrQuote[i].Text;
          break;
        }
      }

      _scLV('quote_box|' + selectedValQuote.replace('/', '_').replace(" ", "_").replace(".", "").toLowerCase() + '_start', 1, 'o');
      buttonClicks++;
    }
  }
  else if (metricName == "RetrieveQuote")
  {
    _scLV('quote_box|retrieve', 1, 'o');
  }
  else if ((metricName == "FindAgentZip") || (metricName == "FindAgentCityState"))
  {
    if (buttonClicks == 0)
    {
      _scLV('quote_box|find_agent', 1, 'o');
      buttonClicks++;
    }
  }
  //else if (metricName == "FindAgentCityState")
  //{
  //  if (buttonClicks == 0)
  //  {
  //    _scLV('quote_box|find_agent', 1, 'o');
  //    buttonClicks++;
  //  }
  //}
  else if (metricName == "ReferAFriendRefer")
  {
    var sc = s_gi(variables[0]);

    sc.linkTrackVars = 'eVar12,eVar41,eVar44,prop21,events';
    sc.linkTrackEvents = 'event48,event59';
    sc.eVar12 = s.prop21 = variables[4] + '|' + variables[5] + '|' + variables[6] + '|' + variables[7] + '|' + variables[8] + '|' + variables[9];
    sc.eVar41 = variables[3] + '|RaF ' + variables[1] + ': Refer ' + variables[2];
    sc.eVar44 = 'RaF ' + variables[1] + ': Refer ' + variables[2];
    sc.events = 'event48,event59';
    
    sc.tl(this, 'o', 'RaF ' + variables[1] + ': Refer ' + variables[2] + ' Start');
  }
  else if (metricName == "ReferAFriendRecommend")
  {
    var sc = s_gi(variables[0]);

    sc.linkTrackVars = 'eVar12,eVar41,eVar44,prop21,events';
    sc.linkTrackEvents = 'event48,event59';
    sc.eVar12 = s.prop21 = variables[4] + '|' + variables[5] + '|' + variables[6] + '|' + variables[7] + '|' + variables[8] + '|' + variables[9];
    sc.eVar41 = variables[3] + '|RaF ' + variables[1] + ': Recommend ' + variables[2];
    sc.eVar44 = 'RaF ' + variables[1] + ': Recommend ' + variables[2];
    sc.events = 'event48,event59';

    sc.tl(this, 'o', 'RaF ' + variables[1] + ': Recommend ' + variables[2] + ' Start');
  }
  else if (metricName == "ReferAFriend")
  {
    var sc = s_gi(variables[0]);

    sc.linkTrackVars = 'eVar12,eVar41,prop21,events';
    sc.linkTrackEvents = 'event49,event60';
    sc.eVar12 = s.prop21 = variables[5] + '|' + variables[6] + '|' + variables[7] + '|' + variables[8] + '|' + variables[9] + '|' + variables[10];
    sc.eVar41 = variables[3] + '|RaF ' + variables[1] + ': ' + variables[2];
    sc.events = 'event49,event60';

    sc.tl(this, 'o', 'RaF ' + variables[1] + ': ' + variables[2] + ' ' + variables[3] + ' Complete');
    
    _scLV(s.pageName.substring(s.pageName.lastIndexOf('/') + 1) + 'ReferAFriend', 1, 'o');
  }
  else if (metricName == 'LoginHead')
  {
    if (buttonClicks == 0)
    {
      _scLV('CustLogin - Customer Login', 1, 'o');
      buttonClicks++;
    }
  }
  else if (metricName == 'Login')
  {
    if (buttonClicks == 0)
    {
      _scLV('quote_box|ccc_login', 1, 'o');
      buttonClicks++;
    }
  }
  else if (metricName == 'LoginIconTopNav') 
  {
    if (buttonClicks == 0) 
    {
        _scLV('Login|IconTopNav_login', 1, 'o');
        buttonClicks++;
     }
  }
  else if (metricName == 'AnimateMoveLeft')
  {
    _scLV('More_content_Right', 1, '0');
  }
  else if (metricName == 'AnimateMoveRight')
  {
    _scLV('More_content_Left', 1, '0');
  }
  else if (metricName == 'AnimateButtonClick')
  {
    imgIndex = variables[0];

    _scLV('More_content_Screen' + (imgIndex + 1), 1, '0');
  }
  else if ((metricName == 'AgentBanner') || (metricName == 'CommonCostlyClaims') || (metricName == 'PremiumGauge'))
  {
    _scLV(variables[0], 1, 'o');
    s.prop12 = s.prop13 = s.prop14 = s.events = s.eVar55 = '';
  }
  //else if (metricName == 'CommonCostlyClaims')
  //{
  //  _scLV(variables[0], 1, 'o');
  //  s.prop12 = s.prop13 = s.prop14 = s.events = s.eVar55 = '';
  //}
  else if ((metricName == 'CommonCostlyClaimsSocial') || (metricName == 'PremiumGaugeSocial') || (metricName == 'SocialWidgets') || (metricName == 'SocialIcons'))
  {
    s.linkTrackVars = "eVar55, events";
    s.linkTrackEvents = "event55";
    s.events = "event55";
    s.eVar55 = variables[0];
    s.tl(this, "o", variables[0]);
    s.events = s.eVar55 = "";
  }
  //else if (metricName == 'PremiumGauge')
  //{
  //  _scLV(variables[0], 1, 'o');
  //  s.prop12 = s.prop13 = s.prop14 = s.events = s.eVar55 = '';
  //}
  //else if (metricName == 'PremiumGaugeSocial')
  //{
  //  s.linkTrackVars = "eVar55, events";
  //  s.linkTrackEvents = "event55";
  //  s.events = "event55";
  //  s.eVar55 = variables[0];
  //  s.tl(this, "o", variables[0]);
  //  s.events = s.eVar55 = "";
  //}
  else if ((metricName == 'GUIhbURL') || (metricName == 'GUIhbTalk'))
  {
    sc1 = variables[0];
    sc2 = variables[1];

    _scPV(sc2 + sc1);
  }
  //else if (metricName == 'GUIhbTalk')
  //{
  //  sc1 = variables[0];
  //  sc2 = variables[1];

  //  _scPV(sc2 + sc1);
  //}
  else if ((metricName == 'ZipOverlayEdit') || (metricName == 'ZipOverlaySave'))
  {
    s.prop12 = s.pageName;
    s.prop13 = variables[0];
    s.prop14 = s.pageName + "|" + variables[0];
    s.prop15 = variables[1];
    
    _scLV(variables[0], 1, 'o');
  }
  //else if (metricName == 'ZipOverlaySave')
  //{
  //  s.prop12 = s.pageName;
  //  s.prop13 = variables[0];
  //  s.prop14 = s.pageName + "|" + variables[0];
  //  s.prop15 = variables[1];
    
  //  _scLV(variables[0], 1, 'o');
  //}
  //else if (metricName == 'SocialWidgets')
  //{
  //  s.linkTrackVars = "eVar55, events";
  //  s.linkTrackEvents = "event55";
  //  s.events = "event55";
  //  s.eVar55 = variables[0];
  //  s.tl(this, "o", variables[0]);
  //  s.events = s.eVar55 = "";
  //}
  //else if (metricName == 'SocialIcons')
  //{
  //  s.linkTrackVars = "eVar55, events";
  //  s.linkTrackEvents = "event55";
  //  s.events = "event55";
  //  s.eVar55 = variables[0];
  //  s.tl(this, "o", variables[0]);
  //  s.events = s.eVar55 = "";
  //}
  else if (metricName == 'ShareButton')
  {
    s.linkTrackVars = "eVar55,events";
    s.linkTrackEvents = "event55";
    s.events = "event55";
    s.eVar55 = variables["providers"] + "-share";
    s.tl(this, 'o', variables["providers"] + "-share");
    s.events = s.eVar55 = "";
  }
  else if (metricName == 'WhatsYourStuffWorthGetStarted')
  {
    s.pageName = variables[0];
    s.prop12 = variables[0];
    s.prop13 = "Allstate Logo";
    s.prop14 = "/RentersHowMuchStuff/GetStarted|Allstate Logo";
  }
  else if ((metricName == 'WhatsYourStuffWorthGetQuote') || (metricName == 'WhatsYourStuffWorthFindAnAgent') || (metricName == 'WhatsYourStuffWorthPrivacy') || (metricName == 'WhatsYourStuffWorthTerms') || (metricName == 'WhatsYourStuffWorthunderwriting'))
  {
    s.pageName = variables[0];
    s.prop12 = variables[0];
    s.prop13 = variables[1];
    s.prop14 = variables[2];
  }
  //else if (metricName == 'WhatsYourStuffWorthFindAnAgent')
  //{
  //  s.pageName = variables[0];
  //  s.prop12 = variables[0];
  //  s.prop13 = variables[1];
  //  s.prop14 = variables[2];
  //}
  //else if (metricName == 'WhatsYourStuffWorthPrivacy')
  //{
  //  s.pageName = variables[0];
  //  s.prop12 = variables[0];
  //  s.prop13 = variables[1];
  //  s.prop14 = variables[2];
  //}
  //else if (metricName == 'WhatsYourStuffWorthTerms')
  //{
  //  s.pageName = variables[0];
  //  s.prop12 = variables[0];
  //  s.prop13 = variables[1];
  //  s.prop14 = variables[2];
  //}
  //else if (metricName == 'WhatsYourStuffWorthunderwriting')
  //{
  //  s.pageName = variables[0];
  //  s.prop12 = variables[0];
  //  s.prop13 = variables[1];
  //  s.prop14 = variables[2];
  //}
  else if ((metricName == 'WhatsYourStuffWorthTwitter') || (metricName == 'WhatsYourStuffWorthFacebook'))
  {
    s.pageName = variables[0];
  }
  //else if (metricName == 'WhatsYourStuffWorthFacebook')
  //{
  //  s.pageName = variables[0];
  //}
  else if (metricName == 'OpenExplore')
  {
    _scLV('Explore Allstate', 1, 'o');
  }
  else if (metricName == 'ExploreLink')
  {
    _scLV(variables[0], 'Explore Allstate', 'o');
  }
  else if (metricName == 'CloseExplore')
  {
    _scLV('Close Explore Allstate', 1, 'o');
  }
}


/*!
//# sourceMappingURL=ProcessMetrics.min.js.map
*/